// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createSettlementNoRegistration} from '../../shared/repositories';

export const createSettlementNoRegistrationReport = () =>
    async(dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const settlementNoRegistrationState = getState().reports.settlementNoRegistration;

        const reportCriteria = {
            dealers: settlementNoRegistrationState.selectedDealers,
            ...settlementNoRegistrationState.criteria
        };

        try {

            const data = await createSettlementNoRegistration(reportCriteria);

            dispatch({
                data,
                type: actions.CREATE_SETTLEMENT_NO_REGISTRATION_REPORT_SUCCESS
            });

            dispatch({
                hasNoResult: data.length < 1,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/settlement-no-registration/action-creators/create-report.js